// Global
import React from 'react';

// Local
import { ProductResponse } from 'lib/services/models/content-response';
import { ActionItem, ActionToolbar } from 'components/helpers/ActionToolbar';
import { ProductDescription } from '../ProductDescription/ProductDescription';
import { ProductDetails } from '../ProductDetails/ProductDetails';
import { ProductPrepInstructions } from '../PrepInstructions/PrepInstructions';
import { ProductConsumerStatements } from '../ProductConsumerStatements/ProductConsumerStatements';
import { ProductIngredients } from '../ProductIngredients/ProductIngredients';
import { ProductNutrition } from '../ProductNutrition/ProductNutrition';
import { useGlobalData } from 'lib/hooks/sitecore/useGlobalData';
import styles from './ProductContentContainer.module.scss';
import {
  AllergenClaimItem,
  ProductAllergenStatement,
} from '../ProductAllergenStatement/ProductAllergenStatement';
import { ProductDisclaimer } from '../ProductDisclaimer/ProductDisclaimer';
import { K12RegulatoryDocs } from '../K12RegulatoryDocs/K12RegulatoryDocs';
import { ProductRelatedResources } from '../ProductRelatedResources/ProductRelatedResources';

export interface ProductContentContainerProps {
  product: ProductResponse;
  contentActionToolbarSettings: ActionItem[];
  contentActionToolbarIdentifier?: string;
  allergenClaims?: AllergenClaimItem[] | null;
  maxClaimsCount?: number;
  hideConsumerStatements?: boolean;
  verticallyAlignTitle?: boolean;
  hideDescription?: boolean;
}

export function ProductContentContainer(props: ProductContentContainerProps) {
  const {
    product,
    contentActionToolbarSettings,
    contentActionToolbarIdentifier,
    allergenClaims,
    maxClaimsCount,
    hideConsumerStatements,
    verticallyAlignTitle,
    hideDescription,
  } = props;
  const { siteName } = useGlobalData();

  return (
    <div className={styles.contentContainer}>
      {/* Absolute positioned background image will go here - whenever enhanced to support image variant container */}
      {/* <EnhancedNextImage/> */}

      <ActionToolbar
        className={styles.contentActionToolbar}
        actions={contentActionToolbarSettings}
        toolbarIdentifier={contentActionToolbarIdentifier}
        variant="vertical"
      />

      <div className={styles.content}>
        <div className={styles.topRow}>
          <div className={styles.leftColumn}>
            {!hideDescription && <ProductDescription product={product} />}
            {siteName === 'GMFS' && <ProductDetails product={product} />}
            <ProductPrepInstructions product={product} />
          </div>

          {!verticallyAlignTitle && (
            <div className={styles.rightColumn}>
              <ProductConsumerStatements
                product={product}
                hideConsumerStatements={hideConsumerStatements}
              />
              <K12RegulatoryDocs product={product} />
              <ProductRelatedResources />
            </div>
          )}
        </div>

        <div className={styles.bottomRow}>
          {/* Variant Dropdown Goes here */}
          {/* <div className={styles.variantDropdown} />
           */}

          {/* PDP  Prep Instructions, Ingredients and Nutrition */}
          <div className={styles.bottomInnerRow}>
            <div className={styles.leftColumn}>
              <ProductIngredients product={product} />
              <ProductAllergenStatement
                product={product}
                allergenClaims={allergenClaims}
                maxClaimsCount={maxClaimsCount}
              />
              <ProductDisclaimer />
            </div>

            <div className={styles.rightColumn}>
              <div className={styles.pdpNutritionWrapper}>
                <div className={styles.pdpNutritionInner}>
                  <ProductNutrition product={product} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
